import moment from "moment/moment";

/**
 * @deprecated Use @/libs/dates/useDates instead
 */
export default function useDates(format = 'YYYY-MM-DD') {

    const defaultTimeZone = "America/New_York";

    /**
     * Returns formatted date string
     *
     * @param date
     * @returns {string}
     */
    const getFormattedDate = (date) => {
        // Check if date is already a Moment.js object
        if (moment.isMoment(date)) {
            return date.utc().format(format);
        }
        return moment(date).utc().subtract(moment().isDST() ? 4 : 5, 'hours').format(format);
        // return moment(date).utc().format(format);
    };

    /**
     * Returns formatted date time string
     *
     * @param date
     * @returns {string}
     */
    const getFormattedDateTime = (date) => {
        if (moment.isMoment(date)) {
            return date.format(`${format} HH:mm`);
        }

        return moment(date).utc().format(`${format} HH:mm`);
    };

    /**
     * Returns an array of date strings between two dates
     * start: 2023-01-01, end: 2023-01-04 => ['2023-01-01', '2023-01-02', '2023-01-03', '2023-01-04']
     *
     * @param start: string
     * @param end: string
     * @returns {string[]}
     */
    const getArrayOfDatesBetweenDates = (start, end) => {
        const dates = [];
        let dateIterator = moment.utc(end);

        while (dateIterator.isSameOrAfter(start)) {
            dates.push(dateIterator.format(format));
            dateIterator = dateIterator.subtract(1, 'days');
        }

        return dates;
    };

    /**
     * Converts number of minutes into formatted time string (hh:mm)
     *
     * @param minutes: string
     * @returns {string}
     */
    const minutesToFormattedString = (minutes) =>
        `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`;

    /**
     * Calculates amount of days between two dates, or between day and now
     *
     * @param start: string | Date
     * @param end: string | Date
     * @returns {number}
     */
    const diffBetweenDates = (start, end = new Date()) => {
        return moment.utc(start).diff(moment(end), 'days');
    };

    /**
     * Converts a timestamp into a formatted date-time string.
     *
     * The function takes a timestamp in ISO 8601 format (e.g., "2022-10-03T21:44:55.000000Z")
     * and converts it into a string formatted as "MM/DD/YYYY HH:mm".
     *
     * @param {string} timestamp - The timestamp in ISO 8601 format to be formatted.
     * @param format
     * @returns {string} The formatted date-time string.
     */
    const formatDateTime = (timestamp, format = 'MM-DD-YYYY HH:mm') => {
        // return moment.utc(timestamp).format(format);
        return moment(timestamp).utc().subtract(moment().isDST() ? 4 : 5, 'hours').format(format);
    };


    return {
        getFormattedDate,
        getFormattedDateTime,
        formatDateTime,
        getArrayOfDatesBetweenDates,
        minutesToFormattedString,
        diffBetweenDates,
        defaultTimeZone
    };
}
